export const tabs = [
  { label: 'ActivityPub', path: 'activity-pub', tab: ':activity_pub' },
  { label: 'Authentication', path: 'authentication', tab: ':authentication' },
  { label: 'Captcha', path: 'captcha', tab: ':captcha' },
  { label: 'Emoji', path: 'emoji', tab: ':emoji' },
  { label: 'Frontend', path: 'frontend', tab: ':frontend' },
  { label: 'HTTP', path: 'http', tab: ':http' },
  { label: 'Instance', path: 'instance', tab: ':instance' },
  { label: 'Job queue', path: 'job-queue', tab: ':job_queue' },
  { label: 'Link Formatter', path: 'link-formatter', tab: ':link_formatter' },
  { label: 'Logger', path: 'logger', tab: ':logger' },
  { label: 'Mailer', path: 'mailer', tab: ':mailer' },
  { label: 'Media Proxy', path: 'media-proxy', tab: ':media_proxy' },
  { label: 'Metadata', path: 'metadata', tab: ':metadata' },
  { label: 'MRF', path: 'mrf', tab: ':mrf' },
  { label: 'Rate limiters', path: 'rate-limiters', tab: ':rate_limiters' },
  { label: 'Web push encryption', path: 'web-push', tab: ':web_push' },
  { label: 'Upload', path: 'upload', tab: ':upload' },
  { label: 'Search', path: 'search', tab: ':search' },
  { label: 'Other', path: 'other', tab: ':other' }
]
